module.exports = __webpack_public_path__ + "static/media/234.3ad64028.webp";